module.exports = [{"type":"hash","text":"Permission Settings"},{"type":"normal","text":"","children":[{"type":"normal","text":"The default permission for newly created APIs is read-only."},{"type":"normal","text":"If you need to perform write operations such as placing an order through the API, you need to modify it to the corresponding permission on the UI."}]}]


//////////////////
// WEBPACK FOOTER
// ./src/config/en-US/authentication/02_permission_set.json
// module id = UG8z
// module chunks = 3